import React from "react";
//#region types
import { MonthTotalReplacementListProps } from "models/propTypes/timeReportingPropTypes";
//#endregion
import TimeReportHelperInstance from "components/timeReporting/timeReportHelper";

const formatHours = (hours: number) => `${TimeReportHelperInstance.formatHours(hours)} h`;

const MonthTotalReplacementList: React.FC<MonthTotalReplacementListProps> = (props) => {
  return (
    <ul>
      {props.replacements.map((replacement) => (
        <li key={replacement.rowName}>
          {`${replacement.rowName}: ${formatHours(replacement.currentTotal)} → ${formatHours(replacement.newTotal)}`}
        </li>
      ))}
    </ul>
  );
};

export default MonthTotalReplacementList;
